export enum JOBS_VIEW {
  GRID = 'grid',
  LIST = 'list',
}

export const LOCALSTORAGE_KEYS = {
  hover_jobs_viewableBy: 'hover_jobs_viewableBy',
  hover_jobs_view: 'hover_jobs_view',
};
